/**
 * Asset Path Utility
 *
 * Chemins vers les fichiers sous `public/` : en **web**, toujours des URLs **absolues**
 * depuis la racine du site (`/Logo/...`) pour que les routes imbriquées (/f/...) fonctionnent
 * (évite `./...` qui casse sous Cloudflare / BrowserRouter).
 */

const isElectronRuntime = () => Boolean(window.electronAPI?.isElectron);

/**
 * @param {string} filename - chemin sous public, ex: 'Logo/qawaem-logo.png'
 */
export const getAssetPath = (filename) => {
  const cleaned = filename.replace(/^\/+/, '');

  if (isElectronRuntime()) {
    return `./${cleaned}`;
  }

  const pub =
    typeof process.env.PUBLIC_URL === 'string' ? process.env.PUBLIC_URL.trim() : '';
  if (pub && pub !== '/' && pub !== '.' && pub !== './') {
    const prefix = pub.replace(/\/$/, '');
    return `${prefix}/${cleaned}`;
  }

  return `/${cleaned}`;
};

/** Fichiers sous `public/Logo/` (racine). Le build Cloudflare (`apps/web-apps/demo`) DOIT aussi les garder sous `demo/public/Logo/` (craco `appPublic` = ce dossier). Sinon `/Logo/qawaem-logo-light.png` 404 → fallback logo sombre. */
export const ASSETS = {
  LOGO_NEW: 'Logo/qawaem-logo.png',           // Dark mode logo
  LOGO_LIGHT: 'Logo/qawaem-logo-light.png',    // Light mode logo
  ICON: 'Logo/qawaem-favicon.png',
  LOGO_OLD: 'qawaem/logo.png',
  IMAGE1: 'image1.png',
};

export const BRAND_QUERY = '?v=qawaem-branding-20261505-f-shell-logo';

/**
 * Logo principal pour `<img>` (web + Electron)
 * @param {boolean} isLightMode - true for light theme logo
 */
export const getLogoPath = (isLightMode = false) =>
  isLightMode
    ? getAssetPath(ASSETS.LOGO_LIGHT)
    : getAssetPath(ASSETS.LOGO_NEW);

/**
 * Logo pour le mode clair (light/white theme)
 */
export const getLogoLightPath = () => getAssetPath(ASSETS.LOGO_LIGHT);

/**
 * Icône / favicon app (Sidebar réduite, etc.)
 */
export const getLogoIconPath = () => `${getAssetPath(ASSETS.ICON)}${BRAND_QUERY}`;

export default getAssetPath;
